<template>
    <div>
        <Modal v-model="modelShow" title="合约列表" width="900" @on-visible-change="onVisibleChange">
            <data-grid ref="lg" :columns="cols" :queryParams="queryParams" :queryUrl="queryUrl" paramsName="params" subListName :autoLoad="false">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" border stripe size="small" @on-selection-change="onSelectionChange" style="margin:10px"></Table>
                </template>
            </data-grid>
            <div slot="footer">
                <Button type="primary" @click="submit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import dataGrid from '@/components/datagrid.vue'
export default {
    props : ['queryParams'],
    components: { dataGrid },
    data() {
        return {
            modelShow: false,
            queryUrl: "http://MID-OPERATE-LEASE/messageService/recycleService/queryContractListToStopBilling",
            selection: [],
            cols: [
                {type: 'selection',width: 60,align: 'center'},
                {title: '合约编号', key: 'id' },
                {title: '剩余计租数', key: 'remainAmount' },
                {title: '租借人归还开放日', key: 'leaseeMinBillingStopDate' },
                {title: '模式类型', key: 'modelId', dict: ['default', 'billingModel'] },
                {title: '接收日期', key: 'deliveredDate' },
                {title: '租期', key: 'rentTerm' },
                {title: '起始数量', key: 'amount' },
                {title: '合伙人', key: 'leaserId', dict: ['bizObjects', 'member',true] },
                { title: '合约类型', key: "rentWay", dict: ['ENUM_CORE-CONTRACT', 'contractEntity.RentWay'] },
                { title: '上游', key: "fromMemberId", dict: ['bizObjects', 'member', true] },
                { title: '备注', key: "remark" },
            ],
        }
    },
    methods: {
        openModal() {
            this.modelShow = true
        },
        onVisibleChange(visible){
            if(visible){
                setTimeout(()=>{
                    this.$refs['lg'].loadFirstPage()
                },50)
            }
        },
        onSelectionChange(selection) {
            this.selection = selection
        },
        submit() {
            if (this.selection.length>0) {
                this.$emit('onFinish', this.selection)
                this.modelShow = false
            }else{
                this.$Message.warning('请选择合约')
            }
        }
    }

}
</script>

<style lang="scss" scoped>
</style>